/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SignupStep } from './';
import {
    SignupStepFromJSON,
    SignupStepFromJSONTyped,
    SignupStepToJSON,
} from './';

/**
 * 
 * @export
 * @interface StepUserDetails
 */
export interface StepUserDetails extends SignupStep {
    /**
     * The first name we could obtain for the user if any (for example from Google)
     * @type {string}
     * @memberof StepUserDetails
     */
    firstName?: string;
    /**
     * The last name we could obtain for the user if any (for example from Google)
     * @type {string}
     * @memberof StepUserDetails
     */
    lastName?: string;
    /**
     * The phone number we could obtain for the user if any (for example from Google)
     * @type {string}
     * @memberof StepUserDetails
     */
    phoneNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StepUserDetails
     */
    edrMatches?: boolean;
}

/**
 * Check if a given object implements the StepUserDetails interface.
 */
export function instanceOfStepUserDetails(value: object): value is StepUserDetails {
    return true;
}

export function StepUserDetailsFromJSON(json: any): StepUserDetails {
    return StepUserDetailsFromJSONTyped(json, false);
}

export function StepUserDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StepUserDetails {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepFromJSONTyped(json, ignoreDiscriminator),
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'edrMatches': json['edrMatches'] == null ? undefined : json['edrMatches'],
    };
}

export function StepUserDetailsToJSON(value?: StepUserDetails | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepToJSON(value, true),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'phoneNumber': value['phoneNumber'],
        'edrMatches': value['edrMatches'],
    };
}

